var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#1E8AF9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6275 13H13.3725C12.7435 13.0007 12.1405 13.2475 11.6957 13.6863C11.2509 14.125 11.0007 14.7199 11 15.3404V27.2553C11.0007 27.8758 11.2509 28.4707 11.6957 28.9095C12.1405 29.3482 12.7435 29.595 13.3725 29.5957H30.6275C31.2565 29.595 31.8595 29.3482 32.3043 28.9095C32.7491 28.4707 32.9993 27.8758 33 27.2553V15.3404C32.9993 14.7199 32.7491 14.125 32.3043 13.6863C31.8595 13.2475 31.2565 13.0007 30.6275 13ZM31.7059 27.2553C31.7056 27.5374 31.5918 27.8078 31.3897 28.0072C31.1875 28.2067 30.9134 28.3188 30.6275 28.3191H13.3725C13.0866 28.3188 12.8125 28.2067 12.6103 28.0072C12.4082 27.8078 12.2944 27.5374 12.2941 27.2553V15.3404C12.2945 15.0584 12.4082 14.788 12.6104 14.5886C12.8125 14.3891 13.0866 14.2769 13.3725 14.2766H30.6275C30.9134 14.2769 31.1875 14.3891 31.3896 14.5886C31.5918 14.788 31.7055 15.0584 31.7059 15.3404V27.2553ZM26.098 32.3617C26.098 32.531 26.0299 32.6933 25.9085 32.813C25.7872 32.9328 25.6226 33 25.451 33H18.549C18.3774 33 18.2128 32.9328 18.0915 32.813C17.9701 32.6933 17.902 32.531 17.902 32.3617C17.902 32.1924 17.9701 32.0301 18.0915 31.9104C18.2128 31.7907 18.3774 31.7234 18.549 31.7234H25.451C25.6226 31.7234 25.7872 31.7907 25.9085 31.9104C26.0299 32.0301 26.098 32.1924 26.098 32.3617Z",
    fill: "#19A3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24L19.5265 20.1009L23.549 22.789L27 19",
    stroke: "#19A3DE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.f5231b58.svg";
export { ForwardRef as ReactComponent };